import project1 from "../assets/projects/project-1.png";
import project2 from "../assets/projects/project-2.jpg";
import project3 from "../assets/projects/project-3.jpg";
import project5 from "../assets/projects/project-5.png";

export const HERO_CONTENT = `Meet a dynamic Bachelor of Computer Science with exceptional skills in web development using the MERN stack, AI/ML Engineering, Python, and Java. This tech enthusiast excels as an IoT Engineer, data analyst, and researcher, with a strong grasp of data structures and algorithms. With a keen eye for detail and a relentless drive for excellence, they bring innovative solutions to every project. Highly motivated and committed to continuous learning, they are passionate about pushing the boundaries of technology and shaping the future of tech. Discover how this blend of talent, dedication, and passion can elevate your projects to new heights.`;

export const ABOUT_TEXT = `I have a Bachelor of Computer Science with expertise in web development (MERN stack), AI/ML Engineering, Python, and Java. 
Proficient as an IoT Engineer, data analyst, and researcher with a strong grasp of data structures and algorithms. Highly 
motivated and detail-oriented, eager to apply a diverse technical skill set to innovative projects and solutions. Committed 
to continuous learning and passionate about advancing technology.`;

export const EXPERIENCES = [
  {
    year: "June 2022 - December 2022",
    role: "Trainee and Intern",
    company: "Devtown",
    description: `As a Full-stack Web Development Trainee and Intern at DevTown, I focused on mastering the MERN stack, which includes 
MongoDB, Express.js, React, and Node.js and CSS technology like tailwind and bootstrap. During my tenure, I developed a 
solid understanding of both front-end and back-end development, enabling me to create dynamic and responsive web 
applications `,
    technologies: ["HTML", "CSS", "JavaScript", "React.js", "Node.js", "MongoDB", "Express.js", "BootStrap", "Tailwind"],
  },
  {
    year: "2021 - 2024",
    role: "Liaison Officer",
    company: "Chandigarh University",
    description: "As a Liaison Officer for an event, specifically assigned to CEOs of companies, my role was to ensure that the high-level executives had a seamless and productive experience",
    technologies: ["Verbal Communication", "Teamwork", "Office Software", "Problem-Solving", "Time Management", "Conflict Resolution"],
  },
  {
    year: "August 2024 - November 2024",
    role: "Software Engineer",
    company: "DSP Coder",
    description: `As an Software Engineer Intern at DSP Coder, I contributed to the front-end and back-end software development process. I was involved in designing and implementing user interfaces, as well as developing server-side logic and database management. This experience allowed me to enhance my skills in software engineering and gain practical knowledge in the field.`,
    technologies: ["Web Development", "Next.js", "Tailwind CSS", "TypeScript"],
  },
  {
    year: "March 2025 - June 2025",
    role: "Programmer Analyst Trainee",
    company: "Cognizant",
    description: `As an Programmer Analyst Trainee Intern at Cognizant, I Worked on my skills in programming and software development. I was involved in various projects that required me to apply my knowledge of programming languages and software development methodologies. I also had the opportunity to work with a team of experienced professionals, which helped me gain valuable insights into the industry.`,
    technologies: ["Java", "JSP", "CSS", "HTML","MySQL","Servlet"],
  },
  {
    year: "July 2025 - Present",
    role: "Ruby on Rails Developer Intern",
    company: "Planet Spark",
    description: `As a Ruby on Rails Developer Intern at Planet Spark, I am responsible for developing and maintaining web applications using the Ruby on Rails framework. My role involves collaborating with cross-functional teams to design and implement new features, as well as optimizing existing code for performance and scalability.`,
    technologies: ["Ruby", "Ruby on Rails", "JavaScript", "PostgreSQL", "HTML", "CSS"],
  },
];

export const PROJECTS = [
  {
    link: "https://github.com/Kunal-Chauhan7/Emotion-Detection",
    title: "Emotion Detection Using Text Input",
    image: project1,
    description:
      "Emotion Detection Using Text Input is a cutting-edge project aimed at creating a robust system that can analyze text and determine the underlying emotions conveyed by the user. Leveraging state-of-the-art natural language processing (NLP) techniques and machine learning algorithms, this project will enable applications to understand and respond to human emotions more effectively.",
    technologies: ["Python", "Pandas", "Scikit-learn", "flask", "Joblib"],
  },
  {
    link: "https://kunal-chauhan7.github.io/TaskManager/",
    title: "Task Management App",
    image: project2,
    description:
      "An application for managing tasks and projects, with features such as task creation, assignment, and progress tracking.",
    technologies: ["HTML", "CSS", "BootStrap", "JavaScript"],
  },
  {
    link: "https://github.com/Kunal-Chauhan7/Portfolio",
    title: "Portfolio Website",
    image: project3,
    description:
      "A personal portfolio website showcasing projects, skills, and contact information.",
    technologies: ["HTML", "CSS", "React", "Bootstrap"],
  },
  {
    link: "https://github.com/Kunal-Chauhan7/PartiRekha",
    title: "social media clone",
    image: project5,
    description:
      "A facebook Clone built with react.js with like features front-End.",
    technologies: ["HTML", "CSS", "React.js", "Tailwind"],
  },
];

export const CONTACT = {
  address: "Bhiwani, Haryana, India",
  phoneNo: "+917404799807 ",
  email: "kunalchauhan1623@gmail.com",
};
